//import css from './css.module.less';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import moment from 'moment';
import qs from 'query-string';
import React, { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Form } from 'src/components/Antd';
import SalesChannelHOC, {
  SelectHOC,
} from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import {
  EnumMultiLanguageType,
  useQueryLanguageListContentEditor,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  getPromotionTag,
  postPromotionTag,
} from 'src/request/salesChannel/promotionTag';
import { NEW } from 'src/tools/constant';
import { onFinishFailed, timeoutScroll } from 'src/tools/helper';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import Detail from './DetailPart';
import Left from './Header/TopLeft';
import Right from './Header/TopRight';
import ProductTable from './Products';
import { switchUuidHooks } from './hooks';
import { SalesChannelModeAccessControlHOC } from 'src/constrains/SalesChannelModeAccessControl';

const formName = 'SalesChannelPromotionTag';
const salesChannelMultiLanguageQueryParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  //  salesChannelMultiLanguageUpdate: true,
};
const salesChannelMultiLanguageParams = {
  [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
};
const PromotionTagEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { isPrimary } = props;
  const currentLanguage = useQueryLanguageListContentEditor();
  const [form] = Form.useForm();
  const m: any = useLocation();
  const { defaultName } = qs.parse(m.search);
  const { uuid, tagUuid }: any = useParams();
  const isNew = tagUuid === NEW;
  const defaultState = {
    salesChannelUuid: uuid,
    uuid: null,
    //name: defaultName || '',
    linkedProducts: [],
    status: null,
    title: defaultName || '',
  };
  const [loaded, setLoaded] = React.useState(false);
  const [data, setData] = React.useState<any>(defaultState);
  const { uuid: _tagUuid } = data;
  switchUuidHooks({ uuid: _tagUuid });
  const getData = () => {
    getPromotionTag(tagUuid, salesChannelMultiLanguageQueryParams).then(
      (res) => {
        setData(res);
        handleOnAssData(res);
        setLoaded(true);
        //return status;
      },
    );
  };

  const handleOnError = (error) => {
    onFinishFailed(formName, error);
    return false;
  };

  const [hasModified, setHasModified] = React.useState(false);
  const [activeTime, setActiveTime] = React.useState({
    beginDate: null,
    beginTime: null,
    endDate: null,
    endTime: null,
  });
  const [backgroundColor, setBackgroundColor] = useState('#CE0000');
  const [textColor, setTextColor] = useState('#FFFFFF');
  const [activeTimeError, setActiveTimeError] = React.useState(false);
  const handleOnAssData = (res) => {
    setData(res);
    const { startTime, endTime, title, linkedProducts, tagStyle } = res;
    const _startDate = startTime
      ? moment(startTime).format('YYYY-MM-DD')
      : null;
    const _startTime = startTime ? moment(startTime).format('HH:mm') : null;
    const _endDate = endTime ? moment(endTime).format('YYYY-MM-DD') : null;
    const _endTime = endTime ? moment(endTime).format('HH:mm') : null;
    setActiveTime({
      beginDate: _startDate,
      beginTime: _startTime,
      endDate: _endDate,
      endTime: _endTime,
    });
    setBackgroundColor(tagStyle.backgroundColor);
    setTextColor(tagStyle.fontColor);
    form.setFieldsValue({
      title,
      linkedProducts,
      // time: [start, end],
    });
  };

  React.useEffect(() => {
    if (isNew) {
      form.setFieldsValue(defaultState);
      setLoaded(true);
    } else {
    }
  }, []);
  React.useEffect(() => {
    if (!isNew) {
      getData();
    }
  }, [currentLanguage]);

  const ele = [
    {
      child: (
        <Detail
          isPrimary={isPrimary}
          time={activeTime}
          timeError={activeTimeError}
          backgroundColor={backgroundColor}
          textColor={textColor}
          onTimeChange={(e) => {
            //  console.log('tie', e);
            setActiveTime(e);
            setHasModified(true);
            setActiveTimeError(false);
          }}
          onBackgroundColorChange={(color) => {
            setBackgroundColor(color);
            setHasModified(true);
          }}
          onTextColorChange={(color) => {
            setTextColor(color);
            setHasModified(true);
          }}
        />
      ),
    },
    ...(isPrimary ? [{ child: <ProductTable /> }] : []),
  ];
  return (
    <React.Fragment>
      {loaded && (
        <Form
          onFinishFailed={handleOnError}
          name={formName}
          onFinish={(values) => {
            //console.log('activeTime', activeTime);
            if (!(activeTime.beginDate && activeTime.beginTime) && isPrimary) {
              timeoutScroll('time-picker-promotion-tag');
              setActiveTimeError(true);
            } else {
              const startTime =
                activeTime.beginDate && activeTime.beginTime
                  ? `${activeTime.beginDate} ${activeTime.beginTime}`
                  : null;

              const endTime =
                activeTime.endDate && activeTime.endTime
                  ? `${activeTime.endDate} ${activeTime.endTime}`
                  : null;
              const _d = isPrimary
                ? {
                    ...(data || {}),
                    startTime,
                    endTime,
                    tagStyle: { backgroundColor, fontColor: textColor },
                    ...values,
                  }
                : { ...(data || {}), ...values };
              // console.log(_d);
              postPromotionTag(_d, salesChannelMultiLanguageParams).then(
                (res) => {
                  setData(res);
                  msg.success(
                    getI18n('salesChannelPromotionTag.index.taghasbeenupdated'),
                  );
                  setHasModified(false);
                },
              );
            }
          }}
          form={form}
          onValuesChange={() => {
            setHasModified(true);
          }}>
          <Layout
            topLeft={<Left />}
            topRight={
              <Right
                hasModified={hasModified}
                onSubmit={() => {
                  form.submit();
                }}
                isNew={isNew}
              />
            }
            elements={ele}
          />
        </Form>
      )}
    </React.Fragment>
  );
};
export default SalesChannelModeAccessControlHOC(
  SalesChannelHOC(SelectHOC(PromotionTagEdit), {
    type: EnumMultiLanguageType.SalesChannelProductPromotionTag,
  }),
);
